var _excluded = ["fixHeight", "footerWrapperClassName", "wrapClassName", "open", "maskClosable", "centered", "onOk", "onCancel", "cancelLoading", "confirmLoading", "okType", "okText", "titleWrapperClassName", "footer", "title", "width", "prefixCls", "children", "fullPage", "className", "style", "okButtonProps"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import Button from "../Button";
import { deleteConfirm } from "./deleteConfirmModal";
import "./style/index.css";
import { CloseOutlined } from '@ant-design/icons';
import { Modal as AntdModal } from 'antd';
import cx from 'classnames';
import React, { useRef } from 'react';
var OriginModal = function OriginModal(props) {
  var _props$fixHeight = props.fixHeight,
    fixHeight = _props$fixHeight === void 0 ? false : _props$fixHeight,
    footerWrapperClassName = props.footerWrapperClassName,
    wrapClassName = props.wrapClassName,
    open = props.open,
    _props$maskClosable = props.maskClosable,
    maskClosable = _props$maskClosable === void 0 ? false : _props$maskClosable,
    centered = props.centered,
    onOk = props.onOk,
    onCancel = props.onCancel,
    cancelLoading = props.cancelLoading,
    confirmLoading = props.confirmLoading,
    _props$okType = props.okType,
    okType = _props$okType === void 0 ? 'primary' : _props$okType,
    _props$okText = props.okText,
    okText = _props$okText === void 0 ? '确定' : _props$okText,
    titleWrapperClassName = props.titleWrapperClassName,
    _props$footer = props.footer,
    footer = _props$footer === void 0 ? 'defaultFooter' : _props$footer,
    title = props.title,
    width = props.width,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'dr-modal' : _props$prefixCls,
    children = props.children,
    _props$fullPage = props.fullPage,
    fullPage = _props$fullPage === void 0 ? false : _props$fullPage,
    className = props.className,
    style = props.style,
    okButtonProps = props.okButtonProps,
    otherProps = _objectWithoutProperties(props, _excluded);
  var titleRef = useRef(null);
  var footerRef = useRef(null);
  //const titleSize = useSize(titleRef);
  //const footerSize = useSize(footerRef);
  var defaultFooter = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-footer-default")
  }, /*#__PURE__*/React.createElement(Button, {
    loading: cancelLoading,
    onClick: onCancel
  }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement(Button, _extends({}, okButtonProps, {
    type: okType,
    loading: confirmLoading,
    onClick: onOk
  }), okText));
  var renderTitle = function renderTitle() {
    if (!title) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: cx("".concat(prefixCls, "-title"), titleWrapperClassName),
      ref: titleRef
    }, title);
  };
  var renderFooter = function renderFooter() {
    if (!footer) {
      return null;
    }
    var footerContent = footer === 'defaultFooter' ? defaultFooter : footer;
    return /*#__PURE__*/React.createElement("div", {
      className: cx("".concat(prefixCls, "-footer"), footerWrapperClassName),
      ref: footerRef
    }, footerContent);
  };
  var titleCom = renderTitle();
  var footerCom = renderFooter();
  //const calcBodyHeight = useMemo(() => {
  //  console.log('titleSize是', titleSize);
  //  const haveTitle = !!titleRef.current;
  //  const haveFooter = !!footerRef.current;
  //  const getDomHeight = (
  //    isHaveDom: boolean,
  //    domRef: Element | null,
  //    addMargin?: boolean,
  //  ) => {
  //    if (!isHaveDom) {
  //      return 0;
  //    }
  //    if (!domRef) {
  //      return 0;
  //    }
  //
  //    const styles = getComputedStyle(domRef);
  //    const styleHeight = styles.height;
  //    let margin = 0;
  //    if (addMargin) {
  //      margin =
  //        Number(styles.marginTop.replace('px', '')) ||
  //        Number(styles.marginBottom.replace('px', '')) ||
  //        0;
  //    }
  //    if (styleHeight.indexOf('px') > -1) {
  //      return Number(styleHeight.replace('px', '')) + margin;
  //    }
  //    return 0;
  //  };
  //  const getContentPaddingHeight = (
  //    isHaveDom: boolean,
  //    domRef: Element | null,
  //  ) => {
  //    if (!isHaveDom) {
  //      return 0;
  //    }
  //    if (!domRef) {
  //      return 0;
  //    }
  //
  //    const styles = getComputedStyle(domRef);
  //    return (
  //      Number(styles.paddingTop.replace('px', '')) +
  //      Number(styles.paddingTop.replace('px', ''))
  //    );
  //  };
  //  const bodyDom = document.querySelector('.ant-modal-content');
  //  const titleDom = document.querySelector(`.${prefixCls} .ant-modal-header`);
  //  const footerDom = document.querySelector(`.${prefixCls} .ant-modal-footer`);
  //  const titleHeight = getDomHeight(haveTitle, titleDom, true);
  //  const footerHeight = getDomHeight(haveFooter, footerDom, true);
  //  const bodyPaddingHeight = getContentPaddingHeight(true, bodyDom);
  //  console.log('高度计算', titleHeight, footerHeight, bodyPaddingHeight);
  //  const extraHeight = fullPage ? 0 : 80; // 非全屏弹窗上下边距40
  //  return `calc(100vh - ${
  //    (titleHeight || 0) + (footerHeight || 0) + extraHeight + bodyPaddingHeight
  //  }px)`;
  //}, [titleSize, footerSize]);
  //const calcBodyStyleFun = useMemo(() => {
  //  const baseStyle = bodyStyle;
  //  if (fullPage) {
  //    return { ...baseStyle, height: calcBodyHeight };
  //  }
  //  return {
  //    ...baseStyle,
  //    height: fixHeight ? calcBodyHeight : 'fit-content',
  //    maxHeight: fixHeight ? 'auto' : calcBodyHeight,
  //  } as CSSProperties;
  //}, [calcBodyHeight, bodyStyle]);
  //useEffect(() => {
  //  setBodyStyle(calcBodyStyleFun);
  //}, [titleSize, footerSize]);
  return /*#__PURE__*/React.createElement(AntdModal, _extends({}, otherProps, {
    open: open,
    className: className,
    style: style,
    title: titleCom,
    footer: footerCom,
    width: fullPage ? '100vw' : width,
    wrapClassName: cx(prefixCls, wrapClassName, fixHeight && 'dr-modal-fixed-height', fullPage ? "".concat(prefixCls, "-fullpage") : "".concat(prefixCls, "-normal")),
    maskClosable: maskClosable,
    centered: fullPage ? centered : true,
    closeIcon: /*#__PURE__*/React.createElement("div", {
      onClick: onCancel
    }, /*#__PURE__*/React.createElement(CloseOutlined, {
      rev: "open"
    }))
  }), children);
};
var Modal = OriginModal;
Modal.info = AntdModal.info;
Modal.success = AntdModal.success;
Modal.error = AntdModal.error;
Modal.warning = AntdModal.warning;
Modal.confirm = AntdModal.confirm;
Modal.useModal = AntdModal.useModal;
Modal.destroyAll = AntdModal.destroyAll;
Modal.config = AntdModal.config;
Modal.deleteConfirm = deleteConfirm;
export default Modal;